import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_URL, ENDPOINTS, postData } from "../../constants/api";
import { useParams } from "react-router-dom";
import { getToken, decodeToken } from '../../utils/TokenUtils';

const ALWAYS_VISIBLE = ["Item"];

const styles = `
@import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&family=DM+Mono:wght@500&display=swap');

.invoice-container {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #232950 !important;
  font-family: 'DM Sans', sans-serif;
}

.invoice-container * {
  box-sizing: inherit;
  font-family: inherit;
}

.invoice-container {
  background: #ffffff;
  width: 210mm;
  margin: 20px auto;
  padding: 0;
  box-shadow: 0 4px 32px rgba(0,0,0,0.12);
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid #dde3ed;
  color: #273279 !important;
}

.header-row {
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  padding: 20px 32px 16px;
  border-bottom: 1px solid #dde3ed;
  gap: 4px;
}

.header-logo-side {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.company-logo {
  height: 100%;
  max-height: 220px;
  min-height: 80px;
  width: auto;
  object-fit: contain;
}

.company-title {
  font-size: 24px;
  font-weight: 700;
  color: #252b50;
  text-align: center;
  letter-spacing: 0.3px;
}

.header-info-side {
  flex: 1;
  text-align: right;
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.header-info-side .company-name {
  font-size: 20px;
  font-weight: 700;
  color: #232950;
  letter-spacing: 0.3px;
  line-height: 1.2;
}

.header-info-side .company-detail {
  font-size: 12px;
  color: #555;
  line-height: 1.5;
}

.invoice-title-badge {
  margin-top: 8px;
  font-size: 22px;
  font-weight: 700;
  letter-spacing: 2px;
  color: #F0801C !important;
  text-transform: uppercase;
}

.header-meta-row {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
  margin-top: 4px;
}

.header-meta-row .meta-item {
  display: grid;
  grid-template-columns: auto auto;
  gap: 6px;
  font-size: 12px;
  text-align: right;
}

.header-meta-row .meta-label {
  font-weight: 700;
  color: #232950;
  text-align: right;
}

.header-meta-row .meta-value {
  color: #444;
  text-align: left;
  min-width: 100px;
}

.banner-container img {
  height: 52px;
  object-fit: contain;
}

.po-meta-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 6px 32px 14px;
  border-bottom: 1px solid #dde3ed;
  font-size: 12px;
  color: #444;
}

.po-meta-address {
  color: #444;
  font-size: 12px;
  line-height: 1.6;
}

.po-meta-details {
  text-align: right;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.po-meta-details .meta-item {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  font-size: 12px;
}

.po-meta-details .meta-label {
  font-weight: 700;
  color: #232950;
}

.po-meta-details .meta-value {
  color: #444;
  min-width: 90px;
  text-align: left;
}

.header-two-col {
  display: grid;
  grid-template-columns: 1fr 1fr;
  border-bottom: 1px solid #dde3ed;
  margin: 16px 32px;
  border: 1px solid #dde3ed;
  border-radius: 4px;
  overflow: hidden;
}

.header-panel {
  padding: 0 0 12px 0;
}

.supplier-panel {
  border-right: 1px solid #dde3ed;
}

.header-two-col.single-col {
  grid-template-columns: 1fr;
}

.panel-title {
  background: #F0801C;
  color: #ffffff;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 1px;
  text-transform: uppercase;
  padding: 7px 16px;
  margin-bottom: 10px;
}

.header-panel .grid-item {
  display: flex;
  align-items: baseline;
  gap: 6px;
  padding: 4px 16px;
  font-size: 12px;
}

.label {
  color: #232950;
  font-weight: 600;
  font-size: 12px;
  flex-shrink: 0;
}

.value {
  color: #333;
  font-weight: 400;
  font-size: 12px;
}

.header-panel .grid-item:first-child .value {
  font-weight: 700;
  font-size: 13px;
  color: #232950;
}

.col-toolbar {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
  padding: 8px 32px;
  background: #f4f7fb;
  border-bottom: 0.5px solid #dde3ed;
}

.col-toolbar-label {
  font-size: 11px;
  color: #5a6a85;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-right: 4px;
  flex-shrink: 0;
}

.col-pill {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 4px 10px;
  border-radius: 99px;
  border: 0.5px solid #dde3ed;
  background: #ffffff;
  cursor: pointer;
  font-size: 11px;
  font-family: 'DM Sans', sans-serif;
  color: #8898aa;
  transition: all 0.15s;
  line-height: 1;
}

.col-pill:hover {
  border-color: #F0801C;
  color: #F0801C;
}

.col-pill.active {
  background: #F0801C;
  border-color: #F0801C;
  color: #ffffff;
}

.col-pill .dot {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: currentColor;
  flex-shrink: 0;
}

.col-reset {
  margin-left: auto;
  padding: 4px 14px;
  font-size: 11px;
  font-family: 'DM Sans', sans-serif;
  border-radius: 6px;
  border: 0.5px solid #dde3ed;
  background: transparent;
  color: #5a6a85;
  cursor: pointer;
  transition: all 0.15s;
}

.col-reset:hover {
  background: #e8f0fb;
  border-color: #F0801C;
  color: #F0801C;
}

.items-table {
  width: calc(100% - 64px);
  margin: 16px 32px 0;
  border-collapse: collapse;
  font-size: 11px;
}

.items-table thead tr {
  background-color: #1a1a2e !important;
  color: #ffffff !important;
}

.items-table thead th {
  background-color: #1a1a2e !important;
  color: #ffffff !important;
  padding: 10px 12px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.5px;
  white-space: nowrap;
}

.th-no {
  width: 40px;
  text-align: center !important;
}

.items-table tbody tr {
  border-bottom: 0.5px solid #dde3ed;
}

.items-table tbody tr:nth-child(even) {
  background: #f7f9fc;
}

.items-table tbody tr:hover {
  background: #e8f0fb;
}

.items-table tbody td {
  padding: 9px 12px;
  color: #2c3a52;
  font-size: 11.5px;
}

.td-no {
  text-align: center;
  color: #666 !important;
  font-size: 12px !important;
}

.right-align {
  text-align: right !important;
  font-family: 'DM Mono', monospace;
  font-size: 12px;
}

.footer-signature-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 1px 32px 0;
  margin-top: 16px;
  gap: 32px;
}

.footer-signature-row.only-totals {
  justify-content: flex-end;
}

.signature-section { flex: 1; max-width: 340px; }
.signature-row { display: flex; gap: 20px; margin-bottom: 28px; }
.signature-label-group { display: flex; flex-direction: column; flex: 1; gap: 6px; }

.signature-label {
  font-size: 10px;
  font-weight: 600;
  color: #5a6a85;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.signature-line {
  border-bottom: 1.5px solid #232950;
  height: 24px;
  display: block;
}

.totals-section {
  min-width: 220px;
  background: #fff;
  border: 1px solid #dde3ed;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 0;
}

.total-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 16px;
  border-bottom: 0.5px solid #dde3ed;
  font-size: 13px;
}

.total-row:last-child {
  border-bottom: none;
  background: #fff;
  font-weight: 700;
  font-size: 14px;
}

.total-key {
  color: #333;
  font-weight: 500;
  font-size: 13px;
}

.total-row:last-child .total-key {
  color: #232950;
  font-weight: 700;
}

.total-value {
  font-family: 'DM Mono', monospace;
  font-weight: 600;
  font-size: 13px;
  color: #232950;
}

.total-row:last-child .total-value {
  color: #232950;
  font-size: 14px;
}

.invoice-bottom-bar {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  padding: 16px 32px 20px;
  margin-top: 20px;
  border-top: 1px solid #dde3ed;
  font-size: 11px;
  color: #555;
}

.terms-section {
  max-width: 45%;
}

.terms-section h4 {
  font-size: 11px;
  font-weight: 700;
  color: #232950;
  margin-bottom: 4px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.terms-section ol {
  padding-left: 14px;
  line-height: 1.6;
  color: #555;
}

.terms-contact {
  margin-top: 8px;
  font-size: 11px;
  color: #555;
}

.authorized-block {
  text-align: right;
}

.authorized-stamp {
  display: inline-block;
  border: 2px solid #F0801C;
  border-radius: 4px;
  padding: 8px 18px;
  font-size: 11px;
  font-weight: 700;
  color: #F0801C;
  letter-spacing: 0.5px;
  text-align: center;
  margin-bottom: 20px;
}

.authorized-text {
  font-size: 10px;
  color: #888;
  text-align: right;
}

.invoice-loading,
.invoice-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 300px;
  gap: 16px;
  color: #5a6a85;
  font-size: 14px;
}

.loading-spinner {
  width: 36px;
  height: 36px;
  border: 3px solid #dde3ed;
  border-top-color: #F0801C;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin { to { transform: rotate(360deg); } }

.invoice-error p { color: #c0392b; font-weight: 500; }

.invoice-error button {
  padding: 8px 20px;
  background: #F0801C;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
  font-family: 'DM Sans', sans-serif;
}

.company-brand {
  display: flex;
  align-items: center;
  gap: 12px;
}

.company-name-block {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.company-name {
  font-size: 25px;
  font-weight: 700;
  color: #232950;
  letter-spacing: 0.3px;
  line-height: 1.2;
}

.company-tagline {
  font-size: 11px;
  color: #F0801C;
  font-weight: 500;
  letter-spacing: 0.3px;
}

.meta-item {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  font-size: 12px;
}

.meta-label {
  font-weight: 700;
  color: #232950;
}

.meta-value {
  color: #444;
  min-width: 90px;
  text-align: left;
}

@media print {
  body {
    background: white;
    margin: 0;
    color: #273279 !important;
  }

  @page {
    margin: 5px;
  }

  .invoice-container {
    box-shadow: none;
    margin: 0;
    border-radius: 0;
    width: 100%;
    border: none;
  }

  .col-toolbar { display: none !important; }

  .items-table thead {
    display: table-header-group;
  }

  .header-row,
  .header-two-col {
    page-break-inside: avoid;
    break-inside: avoid;
  }

  .items-table tbody tr {
    page-break-inside: avoid;
    break-inside: avoid;
  }

  .footer-signature-row,
  .invoice-bottom-bar {
    page-break-inside: avoid;
    break-inside: avoid;
    page-break-before: avoid;
    break-before: avoid;
  }

  .items-table thead th {
    background-color: #1a1a2e !important;
    color: #ffffff !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }

  .panel-title {
    background: #F0801C !important;
    color: #ffffff !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }

  .items-table {
    margin-top: 0;
  }
}
  .wechat-qr-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.wechat-qr-block img {
  width: 155px;
  height: 95px;
  object-fit: contain;
}

.wechat-qr-label {
  font-size: 10px;
  color: #888;
  font-weight: 600;
  letter-spacing: 0.5px;
  text-align: center;
}
`;

const MultiRowPrint = () => {
  const { id, route } = useParams();
  const token = getToken();
  const companyUsername = decodeToken(token, 'username');

  const [company,         setCompany]         = useState({});
  const [supplierTitle, setSupplierTitle] = useState("Supplier");
  const [shipmentTitle, setShipmentTitle] = useState("Shipment");
  const [supplierData,   setSupplierData]   = useState({});
  const [shipmentData,   setShipmentData]   = useState({});
  const [items,           setItems]           = useState({});
  const [columns,         setColumns]         = useState([]);
  const [footerData,      setFooterData]      = useState({});
  const [isLoading,       setIsLoading]       = useState(true);
  const [error,           setError]           = useState(null);
  const [hiddenCols,      setHiddenCols]      = useState(new Set());
  const [isSignatureShow, setIsSignatureShow] = useState(false);

  const [invoiceTitle,    setInvoiceTitle]    = useState("PURCHASE ORDER");
  const [invoiceNo,       setInvoiceNo]       = useState("");
  const [invoiceDate,     setInvoiceDate]     = useState("");
  const [time,            setTime]            = useState("");

  const toggleCol = (col) => {
    setHiddenCols((prev) => {
      const next = new Set(prev);
      next.has(col) ? next.delete(col) : next.add(col);
      return next;
    });
  };

  const visibleColumns = columns.filter(
    (col) => col !== "title" && col !== "item_group" && !hiddenCols.has(col)
  );

  const toggleableColumns = columns.filter(
    (col) => col !== "title" && col !== "item_group" && !ALWAYS_VISIBLE.includes(col)
  );

  useEffect(() => {
    const SIGNATURE_ROUTES = ["InPatient", "Discharge"];
    setIsSignatureShow(SIGNATURE_ROUTES.some((r) => route.includes(r)));
  }, [route]);

  useEffect(() => {
    if (route === "Purchase-int-Print" && columns.length > 0) {
      const HIDDEN_BY_DEFAULT = ["RMB Rate", "Total Dollar", "KES_Rate", "Total KSH", "Shipment Cost", "Total Kenya", "Unit Cost"];
      setHiddenCols(new Set(
        columns.filter(col => HIDDEN_BY_DEFAULT.includes(col))
      ));
    }
  }, [columns, route]);

  useEffect(() => {
    if (!isLoading && !error) {
      const timer = setTimeout(() => window.print(), 1500);
      return () => clearTimeout(timer);
    }
  }, [isLoading, error]);

  useEffect(() => {
    const now = new Date();
    const formatted = `${now.getFullYear()}-${String(now.getMonth()+1).padStart(2,'0')}-${String(now.getDate()).padStart(2,'0')} ${String(now.getHours()).padStart(2,'0')}:${String(now.getMinutes()).padStart(2,'0')}`;
    setTime(formatted);
  }, []);

  // ── Company ─────────────────────────────────────────────────────────────────
  useEffect(() => {
    const fetchCompany = async () => {
      try {
        const response = await axios.get(
          `${API_URL}/${ENDPOINTS.SYS}/getlink/company-info`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        const companyData = response.data.report[0];
        setCompany(companyData);
        if (companyData?.name) document.title = companyData.name;
        if (companyData?.logo) {
          const favicon = document.querySelector("link[rel='icon']");
          if (favicon) favicon.href = `${API_URL}/${companyData.logo}`;
        }
      } catch (err) {
        console.log("Error fetching company:", err);
      }
    };
    fetchCompany();
  }, []);

  // ── Invoice report ──────────────────────────────────────────────────────────
  useEffect(() => {
    const fetchReport = async () => {
      setIsLoading(true);
      setError(null);
      try {
        const body   = { id };
        const url    = `${API_URL}/${ENDPOINTS.SYS}/activityReport/${route}`;
        const result = await postData(url, body);

        const invoiceBlock = result.data.find(
          (d) => d.title?.toLowerCase() === "invoice"
        );
        if (invoiceBlock?.fields) {
          const f = invoiceBlock.fields;
          if (f["title2"])      setInvoiceTitle(f["title2"]);
          if (f["Invoice No"])  setInvoiceNo(f["Invoice No"]);
          if (f["Date"])        setInvoiceDate(f["Date"]);
        }
        // ── Side 1 ──
        const side1   = result.data.find((d) => d.title?.toLowerCase() === "headerside1");
        const header  = result.data.find((d) => d.title?.toLowerCase() === "header");
        const s1      = side1 || header; // headerside1 hadduu jiro isticmaal, haddaan jirin header

        setSupplierData(s1?.fields || {});
        if (s1?.fields?.name) setSupplierTitle(s1.fields.name);

        // ── Side 2 ──
        const side2    = result.data.find((d) => d.title?.toLowerCase() === "headerside2");
        const shipment = result.data.find((d) => d.title?.toLowerCase() === "shipment");
        const s2       = side2 || shipment; // headerside2 hadduu jiro isticmaal, haddaan jirin shipment

        setShipmentData(s2?.fields || {});
        if (s2?.fields?.name) setShipmentTitle(s2.fields.name);

        const itemsData = result.data
          .filter((d) => d.title?.toLowerCase() === "items")
          .map((d) => d.table || d.fields)
          .flat();

        const grouped = itemsData.reduce((acc, item) => {
          const key = item.item_group || "Other";
          if (!acc[key]) acc[key] = [];
          acc[key].push(item);
          return acc;
        }, {});

        setItems(grouped);
        if (itemsData.length > 0) setColumns(Object.keys(itemsData[0]));

        const footer = result.data.find((d) => d.title?.toLowerCase() === "footer");
        setFooterData(footer?.fields || {});
      } catch (err) {
        console.error("Failed to load invoice:", err);
        setError("Xogta invoice-ka lama soo qaadi karin. Fadlan dib u isku day.");
      } finally {
        setIsLoading(false);
      }
    };
    fetchReport();
  }, [id, route]);

    const isImage = (t) => {
      if (!t || typeof t !== 'string') return false;
      return (
        t.toLowerCase().endsWith('.jpg') ||
        t.toLowerCase().endsWith('.png') ||
        t.toLowerCase().endsWith('.jpeg') ||
        t.toLowerCase().endsWith('.gif') ||
        t.toLowerCase().endsWith('.webp') ||
        t.toLowerCase().endsWith('.jfif')
      );
    };

    const buildRows = () => {
      let rowNumber = 1;
      return Object.keys(items).flatMap((group) =>
        items[group].map((item, index) => (
          <tr key={`${group}-${index}`}>
            <td className="td-no">{rowNumber++}</td>
            {visibleColumns.map((col) => (
              <td
                key={col}
                className={
                  col.toLowerCase().includes("price")  ||
                  col.toLowerCase().includes("amount") ||
                  col.toLowerCase().includes("total")  ||
                  col.toLowerCase().includes("cost")   ||
                  col.toLowerCase().includes("rate")
                    ? "right-align" : ""
                }
              >
                {/* ✅ Image render — DTTable-ka la mid ah */}
                {isImage(item[col]) ? (
                  <img
                    src={
                      item[col].includes('http')
                        ? item[col]
                        : `${API_URL}/${item[col]}`
                    }
                    alt="img"
                    style={{
                      width: 75,
                      height: 75,
                      objectFit: 'cover',
                    }}
                  />
                ) : (
                  item[col]
                )}
              </td>
            ))}
          </tr>
        ))
      );
    };

  if (isLoading) return (
    <>
      <style>{styles}</style>
      <div className="invoice-loading">
        <div className="loading-spinner" />
        <p>Invoice loading...</p>
      </div>
    </>
  );

  if (error) return (
    <>
      <style>{styles}</style>
      <div className="invoice-error">
        <p>{error}</p>
        <button onClick={() => window.location.reload()}>Dib u isku day</button>
      </div>
    </>
  );

  return (
    <>
      <style>{styles}</style>
      <div className="invoice-container">

        <div className="header-row">
          <div className="header-logo-side">
            {(company.logo || company.banner) && (
              <img
                src={`${API_URL}/${company.logo || company.banner}`}
                alt={company.name || "Logo"}
                className="company-logo"
              />
            )}
            {company.name && (
              <div className="company-title">{company.name}</div>
            )}
          </div>

          <div className="header-info-side">
            {company.name && (
              <div className="company-name">{company.name}</div>
            )}
            {company.address && (
              <div className="company-detail">{company.address}</div>
            )}
            {(company.country || company.locality) && (
              <div className="company-detail">
                {[company.country, company.locality].filter(Boolean).join(", ")}
              </div>
            )}
            {company.tell && (
              <div className="company-detail">Tel: {company.tell}</div>
            )}
            {company.pobox && (
              <div className="company-detail">P.O. Box: {company.pobox}</div>
            )}
            {company.email && (
              <div className="company-detail">{company.email}</div>
            )}

            <div className="invoice-title-badge">{invoiceTitle}</div>

            <div className="header-meta-row">
              {invoiceNo && (
                <div className="meta-item">
                  <span className="meta-label">InvoiceNo:</span>
                  <span className="meta-value">{invoiceNo}</span>
                </div>
              )}
              {invoiceDate && (
                <div className="meta-item">
                  <span className="meta-label">Date:</span>
                  <span className="meta-value">{invoiceDate}</span>
                </div>
              )}
              <div className="meta-item">
                <span className="meta-label">Username:</span>
                <span className="meta-value">{companyUsername}</span>
              </div>
              <div className="meta-item">
                <span className="meta-label">DatePrinted:</span>
                <span className="meta-value">{time}</span>
              </div>
            </div>
          </div>
        </div>

        <div className={`header-two-col ${Object.keys(shipmentData).length === 0 ? "single-col" : ""}`}>
          <div className="header-panel supplier-panel">
            <div className="panel-title">{supplierTitle}</div>
            {Object.entries(supplierData)
              .filter(([key]) => key !== "Invoice No" && key !== "Date" && key !== "name")
              .map(([key, value]) => (
                <div key={key} className="grid-item">
                  <span className="label">{key}:</span>
                  <span className="value">{value}</span>
                </div>
              ))}
          </div>
          {Object.keys(shipmentData).length > 0 && (
            <div className="header-panel shipment-panel">
              <div className="panel-title">{shipmentTitle}</div>
              {Object.entries(shipmentData)
                .filter(([key]) => key !== "Invoice No" && key !== "Date" && key !== "name")
                .map(([key, value]) => (
                  <div key={key} className="grid-item">
                    <span className="label">{key}:</span>
                    <span className="value">{value}</span>
                  </div>
                ))}
            </div>
          )}
        </div>

        <div className="col-toolbar">
          <span className="col-toolbar-label">Columns:</span>
          {toggleableColumns.map((col) => (
            <button
              key={col}
              className={`col-pill ${!hiddenCols.has(col) ? "active" : ""}`}
              onClick={() => toggleCol(col)}
            >
              <span className="dot" />
              {col}
            </button>
          ))}
          {hiddenCols.size > 0 && (
            <button className="col-reset" onClick={() => setHiddenCols(new Set())}>
              Show all
            </button>
          )}
        </div>

        <table className="items-table">
          <thead>
            <tr>
              <th className="th-no">S.No</th>
              {visibleColumns.map((col) => (
                <th key={col}>{col}</th>
              ))}
            </tr>
          </thead>
          <tbody>{buildRows()}</tbody>
        </table>

        {route !== "More-nurse" && (
          <div className={`footer-signature-row ${!isSignatureShow ? "only-totals" : ""}`}>
            {isSignatureShow && (
              <div className="signature-section">
                <div className="signature-row">
                  <div className="signature-label-group">
                    <span className="signature-label">Approved By:</span>
                    <span className="signature-line" />
                  </div>
                  <div className="signature-label-group">
                    <span className="signature-label">Sign</span>
                    <span className="signature-line" />
                  </div>
                  <div className="signature-label-group">
                    <span className="signature-label">Date:</span>
                    <span className="signature-line" />
                  </div>
                </div>
                <div className="signature-row">
                  <div className="signature-label-group">
                    <span className="signature-label">Discharged By:</span>
                    <span className="signature-line" />
                  </div>
                  <div className="signature-label-group"><span className="signature-line" /></div>
                  <div className="signature-label-group"><span className="signature-line" /></div>
                </div>
              </div>
            )}
            <div className="totals-section">
              {Object.keys(footerData).map((key) => (
                <div key={key} className="total-row">
                  <span className="total-key">{key}</span>
                  <span className="total-value">{footerData[key]}</span>
                </div>
              ))}
            </div>
          </div>
        )}
{route === "Purchase-int-Print" && (<div className="invoice-bottom-bar">
  <div className="terms-section">
    {/* ...existing terms content... */}
  </div>

  {/* ── WeChat QR ── */}
  <div className="wechat-qr-block">
    <img
      src={`${API_URL}/uploads/company/wechat.jfif`}
      alt="WeChat QR Code"
    />
    <span className="wechat-qr-label">WeChat scan</span>
  </div>

  <div className="authorized-block">
    {/* ...existing authorized content... */}
  </div>
</div>)}
      </div>
    </>
  );
};

export default MultiRowPrint;